<template>
  <van-search
    v-model="value"
    :placeholder="placeholder"
    @input="onInput"
    @focus="focus"
    @blur="blur"
    class="home-search"
  >
    <!-- <template #right-icon>
			<van-button @click="onSearch" type="info" size="small" class="search-btn">搜索</van-button>
		</template> -->
  </van-search>
</template>

<script>
export default {
  props: ["list", "searchKey", "placeholder", "oldList"],
  data() {
    return {
      value: "",
      searchList: [],
      timer: null,
    };
  },
  methods: {
    onInput() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        // 执行搜索请求
        console.log(this.value);
      }, 2000); // 设置时间

      // console.log(this.value);
      if (this.value) {
        let newList = [];
        let searchListId = []; // 仅用于检查去重
        let key = this.searchKey;
        let setList = [];
        if (typeof this.searchKey === "object") {
          this.list.forEach((item) => {
            for (let i = 0; i < key.length; i++) {
              if (
                item[key[i]].indexOf(this.value) > -1 &&
                searchListId.indexOf(item.netId) == -1
              ) {
                newList.push(item);
                searchListId.push(item.netId);
              }
            }
          });
        } else {
          this.list.forEach((item) => {
            if (item[key].indexOf(this.value) > -1) {
              newList.push(item);
            }
          });
        }
        this.searchList = newList;
      } else {
        this.searchList = this.oldList;
      }
      this.$emit("get", this.searchList);
    },

    focus() {
      this.$emit("focus");
    },
    blur() {
      this.$emit("blur");
    },
  },
};
</script>

<style lang="scss">
.van-search__content {
  background-color: #fff;
  padding-left: 0;
}
</style>
